import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "@/shared/lib/utils";

import { Label } from "../primitives/label";

type ColocaLabelProps = ComponentPropsWithoutRef<"label">;

export const ColocaLabel = forwardRef<HTMLLabelElement, ColocaLabelProps>(function ColocaLabel(
  { className, ...rest },
  ref,
) {
  return <Label ref={ref} className={cn(className)} {...rest} />;
});
